import { BlockStack, ChoiceList, Modal, TextField } from '@shopify/polaris'
import { openSupport } from '@services/support'
import { Fragment, useState } from 'react'

interface IProps {
  isOpen: boolean
  onClose: () => void
  satisfiedContent?: string
}

const ModalNegative = (props: IProps) => {
  //! Props
  const { isOpen, onClose, satisfiedContent = '' } = props
  //! State
  const [selected, setSelected] = useState<string[]>([])
  const [valueOther, setValueOther] = useState<string>('')
  //! Function

  //! Effect

  //! Render
  return (
    <Fragment>
      {isOpen && (
        <Modal
          title="Share your experience with us"
          onClose={onClose}
          open={isOpen}
          primaryAction={{
            content: 'Send',
            onAction: () => {
              const result = selected?.map(el => {
                if (el === 'Other') {
                  return `${valueOther ? `${el} (${valueOther})` : el}`
                } else return el
              })
              void openSupport({
                source: 'modal_negative',
                topic: 'rating_feedback',
                message: satisfiedContent
                  ? `${satisfiedContent}: ${result?.join(', ')}`
                  : result?.join(', '),
              })
              setSelected([])
              onClose && onClose()
            },
          }}
          secondaryActions={[
            {
              content: 'Close',
              onAction: onClose,
            },
          ]}
        >
          <Modal.Section>
            <BlockStack gap={'400'}>
              <ChoiceList
                title="Your feedback is invaluable to us. If your experience was not as
                expected, please let us know how we can improve. Choose from the
                points below to share your thoughts and help us enhance our app.
                Thank you for your support and insights!"
                choices={[
                  {
                    label: 'User Interface and Experience',
                    value: 'User Interface and Experience',
                    helpText: 'Is the design intuitive and easy to navigate?',
                  },
                  {
                    label: 'Performance and Stability',
                    value: 'Performance and Stability',
                    helpText:
                      'Is the app performing smoothly? Any issues with speed or bugs',
                  },
                  {
                    label: 'Features and Tools',
                    value: 'Features and Tools',
                    helpText:
                      'Are the current features meeting your needs? What additional features would you like to see?',
                  },
                  {
                    label: 'Support and Documentation',
                    value: 'Support and Documentation',
                    helpText:
                      'Was the support you received helpful? Are the guides and documentation clear and comprehensive?',
                  },
                  {
                    label: 'Value and Pricing',
                    value: 'Value and Pricing',
                    helpText:
                      'Do you find the app offers good value for its cost? Are the pricing plans suitable for your needs?',
                  },
                  {
                    label: 'Overall Satisfaction',
                    value: 'Overall Satisfaction',
                    helpText:
                      'How would you rate your overall experience with the app? What could we do better?',
                  },
                  {
                    label: 'Other',
                    value: 'Other',
                    helpText:
                      'If you have any other feedback or suggestions, please feel free to share them with us.',
                    renderChildren: (isSelected: boolean) => (
                      <Fragment>
                        {isSelected && (
                          <TextField
                            label
                            labelHidden
                            value={valueOther}
                            onChange={(value: string) => setValueOther(value)}
                            autoComplete="off"
                            placeholder="Your feedback or suggestions"
                          />
                        )}
                      </Fragment>
                    ),
                  },
                ]}
                allowMultiple
                selected={selected}
                onChange={(value: string[]) => setSelected(value)}
              />
            </BlockStack>
          </Modal.Section>
        </Modal>
      )}
    </Fragment>
  )
}

export default ModalNegative
